import PropTypes from 'prop-types';
import React from 'react';
import VideoList from './video_list';
import { API_KEY } from '../legacy/youtube_api';
import { debounce } from 'lodash';

const MIN_CHARACTERS = 3;

class Videos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      videos: [],
      term: '',
      selectedVideo: null,
      videoLink: this.props.videoLink || '',
      error: false,
    };

    this.youtubeSearch = debounce(this.youtubeSearch, 200);
  }

  onKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  handleVideoSelection(selectedVideo) {
    const videoId = selectedVideo.id.videoId;
    const link = `https://www.youtube.com/watch?v=${videoId}`;

    this.setState({
      selectedVideo,
      videoLink: link,
      videos: [selectedVideo],
    });
  }

  handleVideoRemove() {
    this.setState({
      videos: [],
      term: '',
      selectedVideo: null,
      videoLink: '',
    });
  }

  handleLinkChange(videoLink) {
    this.setState({ videoLink });
  }

  handleSearchChange(term) {
    this.setState({
      term,
      selectedVideo: null,
      videos: term === '' ? [] : this.state.videos,
    });

    this.youtubeSearch(term);
  }

  isReverbVideo(video) {
    return video.snippet.channelTitle === 'Reverb.com';
  }

  sortByReverbFirst(videos) {
    return videos.sort((a, b) => {
      const aComparator = this.isReverbVideo(a) ? 1 : 0;
      const bComparator = this.isReverbVideo(b) ? 1 : 0;
      return bComparator - aComparator;
    });
  }

  meetsMinCharacters(term) {
    return term.trim().length >= MIN_CHARACTERS;
  }

  youtubeSearch(term) {
    if (!this.meetsMinCharacters(term)) { return; }

    $.get('https://www.googleapis.com/youtube/v3/search', {
      key: API_KEY,
      safeSearch: 'strict',
      q: term,
      part: 'snippet',
      maxResults: 6,
    }).done((searchResults) => {
      const videoArray = this.sortByReverbFirst(searchResults.items);
      this.setState({ videos: videoArray, error: false });
    }).fail(() => {
      this.setState({ error: true });
    });
  }

  shouldRenderVideoList() {
    return !this.state.error && this.state.videos.length > 0;
  }

  renderErrorState() {
    return (
      <div className="alert alert-small alert-error">
        {I18n.t('js.listingForm.videos.youtubeSearchError')}
      </div>
    );
  }

  render() {
    return (
      <div className="form-group">
        <div className="form-group__header">
          <label>
            <i className="fa fa-youtube-play mr-half" />
            {I18n.t('js.listingForm.videos.linkToVideo')}
          </label>
          <span className="form-group__help-text mtb-0 ml-half">
            {I18n.t('js.listingForm.videos.pasteLink')}
          </span>
        </div>
        <div className="form-group__fields">
          <div className="youtube-embed-form">
            <div className="youtube-embed-form__input-col">
              <input
                name="product[video_link_attributes][link]"
                id="product_video_link_attributes_link"
                type="text"
                className="wide mb-0"
                value={this.state.videoLink}
                onChange={event => this.handleLinkChange(event.target.value)}
                placeholder={I18n.t('js.listingForm.videos.youtubeLinkPlaceholder')}
              />
            </div>
            <div className="youtube-embed-form__or-col">
              {I18n.t('js.listingForm.videos.or')}
            </div>
            <div className="youtube-embed-form__input-col">
              <label className="show-only-on-mobile">
                {I18n.t('js.listingForm.videos.searchYouTubeLabel')}
              </label>
              <input
                type="text"
                className="js-youtube-search-input wide mb-0"
                value={this.state.term}
                onChange={event => this.handleSearchChange(event.target.value)}
                placeholder={I18n.t('js.listingForm.videos.searchYouTubePlaceholder')}
                onKeyPress={event => this.onKeyPress(event)}
              />
            </div>
          </div>
          {this.state.error && this.renderErrorState()}
          {this.shouldRenderVideoList() &&
            <VideoList
              handleVideoSelection={selectedVideo => this.handleVideoSelection(selectedVideo)}
              videos={this.state.videos}
              selectedVideo={this.state.selectedVideo}
              handleVideoRemove={removedVideo => this.handleVideoRemove(removedVideo)}
            />
          }
        </div>
      </div>
    );
  }
}

Videos.propTypes = {
  videoLink: PropTypes.string,
};

export default Videos;
